module.exports = function _arrayOf() {
  return Array.prototype.slice.call(arguments);
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/ramda/src/internal/_arrayOf.js
 ** module id = 264
 ** module chunks = 0
 **/